import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export const useDeleteExternalIntegrationFieldMappingMutation = ({
	onError,
	onSuccess,
	impersonationContext,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: () => void;
	impersonationContext?: Api.IImpersonationContext;
} = {}) => {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: ({
			integrationProvider,
			objectType,
			externalFieldName,
		}: {
			integrationProvider: Api.IntegrationProvider;
			objectType: string;
			externalFieldName: string;
		}) => {
			return userSession.webServiceHelper.callAsync(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `integrations/${integrationProvider}/fieldMappings/${objectType}/${externalFieldName}`,
				}),
				'DELETE'
			);
		},
		onError,
		onSuccess,
	});
};
